import { BENEFIT_INIT_LOADING, BENEFIT_INIT_SUCCESS, BENEFIT_INIT_FAIL } from '@/store/types'
export const benefit = {
  [BENEFIT_INIT_LOADING](state) {
    state.benefit.init = 0
    state.benefit.initErr = []
    state.benefit.menu = {}
  },
  [BENEFIT_INIT_SUCCESS](state, data) {
    state.benefit.init = 1
    state.benefit.initErr = []
    state.benefit.menu = data.menu
  },
  [BENEFIT_INIT_FAIL](state, error) {
    state.benefit.init = 2
    state.benefit.initErr = error
    state.benefit.menu = {}
  }
}
